import React from "react"
import { Container, Row, Col, Form } from "react-bootstrap"
import useForm from "../useForm"
import { coverAmtOptions, lengthOfCoverOptions } from "../../data/formOptions"

const MultiCover = props => {
  const { values, handleChange, handleTermChange } = props
  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col>
            {/* <Form autoComplete="on"> */}
              {/* <---------------FIRST ROW--------------->*/}
              <Form.Row>
                <Form.Group as={Col} controlId="amountOfCover">
                  <div className="row-question">
                    <Form.Label>Amount of cover required?</Form.Label>
                    <Form.Control
                      as="select"
                      name="amountOfCover"
                      value={values.amountOfCover}
                      onChange={handleChange}
                      className="select"
                    >
                      {/* map through list of values from coverAmtOptions in formOptions.js*/}
                      {coverAmtOptions.map(({ value, formattedValue }) => (
                        <option key={value} value={value}>
                          {formattedValue}
                        </option>
                      ))}
                    </Form.Control>
                  </div>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="lengthOfCover">
                  <div className="row-question">
                    <Form.Label>Length of cover?</Form.Label>
                    <Form.Control
                      as="select"
                      name="lengthOfCover"
                      value={values.lengthOfCover}
                      onChange={handleTermChange}
                      className="select"
                    >
                      {lengthOfCoverOptions.map(({ value, formattedValue }) => (
                        <option key={value} value={value}>
                          {formattedValue}
                        </option>
                      ))}
                    </Form.Control>
                  </div>
                </Form.Group>
              </Form.Row>
            {/* </Form> */}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default MultiCover
